import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { formatTime } from '../utils/formats';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTimeWatcherContext } from '../TimeWatcherProvider';
import Skeleton from '@mui/material/Skeleton';

function DigitalClock({ clockAmPm }) {
  const { curTime } = useTimeWatcherContext();
  if (!curTime) {
    return (
      <Typography variant="h4">
        <Skeleton variant="text" />
      </Typography>
    );
  }
  const formattedTime = formatTime(curTime, { clockAmPm });
  return <Time>{formattedTime}</Time>;
}

DigitalClock.propTypes = {
  clockAmPm: PropTypes.bool,
};

export default memo(DigitalClock);

const Time = styled((props) => (
  <Typography variant="h4" component="div" {...props} />
))(({ theme }) => ({
  display: 'block',
  textAlign: 'center',
  width: '100%',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down('tablet')]: {
    fontSize: theme.typography.h3.fontSize,
  },
}));
